
import { Component, Vue } from "vue-property-decorator";

@Component
export default class ManualAdd extends Vue {

  prev() {
    this.$router.push({ name: "qa-add-patent" });
  }

  next() {
    this.$router.push({ name: "qa-order" });
  }

}
